import { Flex, Input, Radio, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { EXPIRATION_TYPE } from './constants'
import './index.scss'
import { useWindowSize } from 'src/app/shared/hooks/useWindowSize'

interface IExpiration {
  control: Control<any>
  errors?: FieldErrors<any>
  trigger: any
  clearErrors: any
}

const Expirations = (props: IExpiration) => {
  const { t } = useTranslation()
  const { mode } = useWindowSize()
  const { control, errors, trigger, clearErrors } = props

  const handleOnchangeInput = (e: any, inputField: any, name: string) => {
    let inputValue = e.target.value
    inputValue = inputValue.trim().replace(/\D/g, '')

    const e1: any = e
    e1.target.value = inputValue
    inputField.onChange(e1)
    trigger(name)
  }

  return (
    <Flex vertical style={{ marginBottom: 16 }}>
      <Typography className='title' style={{ marginBottom: 12 }}>
        {t('UserRoles:expirations')}
      </Typography>

      <Controller
        name='expirations'
        control={control}
        render={({ field }) => (
          <Radio.Group
            {...field}
            name='expirations'
            style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}
            onChange={(e) => {
              field.onChange(e)

              if (e.target.value === EXPIRATION_TYPE.EXPIRE_X_MINUTES) {
                clearErrors('expirationMinutes')
              }
              if (e.target.value === EXPIRATION_TYPE.EXPIRE_X_DAYS) {
                clearErrors('expirationDays')
              }
            }}
          >
            <Radio value={EXPIRATION_TYPE.DOES_NOT_EXPIRE} className='radio-wrapper-first'>
              <Typography className='expiration-option'>{t('UserRoles:doesNotExpire')}</Typography>
            </Radio>
            <Radio value={EXPIRATION_TYPE.EXPIRE_X_MINUTES} className='radio-wrapper'>
              <Flex gap={16} align='flex-start' style={{ flexDirection: mode === 'mobile' ? 'column' : undefined }}>
                <Typography className='expiration-option'>{t('UserRoles:durationExpiresInMinutes')}</Typography>
                <Flex vertical justify='flex-start' style={{ width: '100%' }}>
                  <Controller
                    name='expirationMinutes'
                    control={control}
                    render={({ field: inputField }) => (
                      <Input
                        {...inputField}
                        style={{ maxWidth: 376, width: '100%' }}
                        status={errors?.expirationMinutes ? 'error' : ''}
                        placeholder={t('UserRoles:enterMinutes')}
                        maxLength={10}
                        disabled={field.value !== EXPIRATION_TYPE.EXPIRE_X_MINUTES}
                        name='expirationMinutes'
                        onChange={(e) => {
                          handleOnchangeInput(e, inputField, 'expirationMinutes')
                        }}
                      />
                    )}
                  />
                  {errors?.expirationMinutes && (
                    <Typography className='error-message'>
                      <ErrorMessage errors={errors} name='expirationMinutes' />
                    </Typography>
                  )}
                </Flex>
              </Flex>
            </Radio>
            <Radio value={EXPIRATION_TYPE.EXPIRE_X_DAYS} className='radio-wrapper'>
              <Flex gap={16} align='flex-start' style={{ flexDirection: mode === 'mobile' ? 'column' : undefined }}>
                <Typography className='expiration-option'>{t('UserRoles:durationExpiresInDays')} </Typography>
                <Flex vertical justify='flex-start' style={{ width: '100%' }}>
                  <Controller
                    name='expirationDays'
                    control={control}
                    render={({ field: inputField }) => (
                      <Flex align='flex-end'>
                        <Input
                          {...inputField}
                          style={{ maxWidth: 376, width: '100%' }}
                          status={errors?.expirationDays ? 'error' : ''}
                          placeholder={t('UserRoles:enterDays')}
                          maxLength={10}
                          disabled={field.value !== EXPIRATION_TYPE.EXPIRE_X_DAYS}
                          name='expirationDays'
                          onChange={(e) => {
                            handleOnchangeInput(e, inputField, 'expirationDays')
                          }}
                        />
                      </Flex>
                    )}
                  />
                  {errors?.expirationDays && (
                    <Typography className='error-message'>
                      <ErrorMessage errors={errors} name='expirationDays' />
                    </Typography>
                  )}
                </Flex>
              </Flex>
            </Radio>
          </Radio.Group>
        )}
      />
    </Flex>
  )
}

export default Expirations
